import {FAQ} from 'components/FAQ';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import React from 'react';

const FaqPage = () => {
  return (
    <Layout>
      <SEO title='comachicart' path='faq' />
      <FAQ />
    </Layout>
  );
};

export default FaqPage;